import React,{useEffect,useState} from "react";
import Axios from 'axios';
import Coin from "./Coin";
export default function CryptoTracker(){
    const[allCoins,setAllCoins]=useState([]);
    const[search,setSearch]=useState('')
    useEffect(()=>{
Axios.get("https://api.coinstats.app/public/v1/coins?skip=0").then((response)=>{
    setAllCoins(response.data.coins)
})
    },[])
    const filterCoin=allCoins.filter((coin)=>{
            return  coin.name.toLowerCase().includes(search.toLowerCase());
    })            


    return(
        <div className="centerBody">
<div className="styleInput">
        <input text="text" placeholder="Search Crypto.." value={search} onChange={(e)=>{setSearch(e.target.value)}}/>
       </div>
      

        <div className="coinStyle">
        <div className="coinDisplay">
        {filterCoin.map((coin)=>{
            return ( 
            <Coin name={coin.name}
           
             price={coin.price} 
             icon={coin.icon}
              symbol={coin.symbol}
            />
           
       ) })}
       
        </div>
    
       
        
            
       </div>
    
       
        
        </div>
    )
    }